export default "/_next/static/assets/images/qrcode-blick-app-de.d763b61eeb8dcd5b74dbf95521f1c067.svg";